import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { currencyFormat } from '@fiverr-private/localization';
import { useLocalizationContext } from '../../hooks/LocalizationContext';

export interface HourlyOrderCardProps {
    hourlyRate: number;
    sellerName: string;
    onClick?: () => void;
}

export const HourlyOrderCard = ({ hourlyRate, sellerName, onClick }: HourlyOrderCardProps) => {
    const { currency } = useLocalizationContext();

    return (
        <Stack
            direction="column"
            justifyContent="spaceBetween"
            backgroundColor="business_100"
            padding="5"
            borderWidth="sm"
            borderRadius="sm"
            width="100%"
            height="100%"
            boxShadow="z1"
            cursor="pointer"
            role="button"
            onClick={onClick}
            minWidth="256px"
            minHeight="210px"
        >
            <Container>
                <Text fontWeight="bold" size="b_xl">
                    <I18n
                        k="seller_pages_toolbox.hourly_order_card.title"
                        templates={{
                            italic: (text) => (
                                <Typography as="span" fontStyle="italic" fontWeight="normal" fontFamily="domaine">
                                    {text}
                                </Typography>
                            ),
                        }}
                    />
                </Text>
                <Text fontWeight="bold" size="b_xl">
                    <I18n
                        k="seller_pages_toolbox.hourly_order_card.sub_title"
                        params={{
                            sellerName,
                        }}
                    />
                </Text>
            </Container>
            <Stack direction="row" justifyContent="spaceBetween" wrap="wrap" alignItems="flexEnd">
                <Text size="b_sm" fontWeight="semibold">
                    <Stack alignItems="flexEnd" gap="1">
                        <Typography size="b_lg">
                            {currencyFormat({
                                value: hourlyRate * (currency?.rate || 1),
                                currencyCode: currency?.name,
                            })}
                        </Typography>
                        <Typography>{' / '}</Typography>
                        <I18n k="seller_pages_toolbox.hourly_order_card.hour" />
                    </Stack>
                </Text>
                <Container>
                    <Button
                        variant="outline"
                        size="sm"
                        style={{ whiteSpace: 'nowrap' }}
                        data-testid="ask-about-hourly-orders-button"
                    >
                        <I18n k="seller_pages_toolbox.hourly_order_card.ask_button" />
                    </Button>
                </Container>
            </Stack>
        </Stack>
    );
};
